import { BookkeeperCompanyIncidenceOptionFragment } from 'generated/resources/graphql'

import type { IncidenceOptionsType } from 'modules/bookkeepers/lib/incidenceOptions'
import { incidenceTrackingBlocked } from 'modules/bookkeepers/lib/incidenceTrackingBlocked'
import { translatedHelpers } from 'modules/bookkeepers/lib/translationHelpers'
import { INCIDENCE_TYPES } from 'modules/payroll_bundle/lib/Incidences/Types'

export const useGetPayrollDataIncidenceOptions = (
  loadingCompanySettings: boolean,
  companySettings: BookkeeperCompanyIncidenceOptionFragment[]
): IncidenceOptionsType[] => {
  if (loadingCompanySettings) {
    return []
  }
  const fixedIncidenceTypes = new Set(Object.values(INCIDENCE_TYPES))

  const payrollDataIncidenceOptions = companySettings.filter((model) => {
    return !fixedIncidenceTypes.has(model.incidenceName)
  })

  return payrollDataIncidenceOptions.map((model) => {
    return {
      id: model.incidenceName,
      name: model.incidenceName,
      identifier: model.incidenceName,
      disabled: incidenceTrackingBlocked(model.incidenceName),
      ...translatedHelpers(model.incidenceName),
    }
  })
}
